import AutoCompletions from "./AutoCompletions";
import Checkbox from "./Checkbox";
import DateInput from "./DateInput";
import EmailInput from "./EmailInput";
import Input from "./Input";
import Password from "./Password";
import PlaceSearch from "./PlaceSearch";
import Radio from "./Radio";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import SelectLight from "./SelectLight";
import Textarea from "./Textarea";
export default {
    AutoCompletions: AutoCompletions,
    Checkbox: Checkbox,
    DateInput: DateInput,
    EmailInput: EmailInput,
    Input: Input,
    Password: Password,
    PlaceSearch: PlaceSearch,
    Radio: Radio,
    RadioGroup: RadioGroup,
    Select: Select,
    SelectLight: SelectLight,
    Textarea: Textarea,
};
//# sourceMappingURL=index.js.map